const subLedger = {
  path: 'subLedger',
  component: resolve => require(['@/pages/admin/merchant/signing/yftWeChat/subLedger'], resolve),
  meta: {isSubLedger: true}
}

export default subLedger
